import {
	AutocompleteArrayInput,
	AutocompleteInput,
	ReferenceArrayInput,
	ReferenceInput,
	TextInput,
	required,
	useRecordContext,
} from "react-admin";
import { OrganEventRecord } from "./types";
import { organEventNameValidator } from "../../validators";

export const OrganEventForm = () => {
	const { organ_id } = useRecordContext<OrganEventRecord>();

	return (
		<>
			<ReferenceInput source="organ_id" reference="organs">
				<AutocompleteInput
					validate={required()}
					optionText="name"
					fullWidth
					disabled
				/>
			</ReferenceInput>
			<TextInput source="name" validate={organEventNameValidator} fullWidth />
			<ReferenceInput
				source="depends_on"
				reference="organ-events"
				filter={{ organ_id: organ_id }}
				allowEmpty
				resettable
			>
				<AutocompleteInput optionText="name" fullWidth />
			</ReferenceInput>
			<ReferenceArrayInput
				source="channel_ids"
				reference="channels"
				filter={{ organ_id: organ_id }}
			>
				<AutocompleteArrayInput
					optionText="name"
					label="Notification channels"
					fullWidth
				/>
			</ReferenceArrayInput>
		</>
	);
};
